import dateComparator from "./DateComparator";

import filterParams from "./DateFilter";

export const columnDefs_Ordo_Examen_Comp = [
  {
    headerName: "idExamens_Compl",
    field: "idExamens_Compl",

    hide: true,
  },
  {
    headerName: "nom_Examens_Compl",
    field: "nom_Examens_Compl",

    hide: true,
  },
  {
    headerName: "fk_id_patient_examen_compl",
    field: "fk_id_patient_examen_compl",

    hide: true,
  },
  {
    checkboxSelection: true,
    headerName: "Création",
    field: "date_exam_compl_converted",
    // filterParams: {
    //     defaultOption: 'startsWith',
    // },
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    comparator: dateComparator,
  },
  {
    // checkboxSelection: true,
    headerName: "Modification",
    field: "dateModificationLisible",
    // filterParams: {
    //     defaultOption: 'startsWith',
    // },
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    comparator: dateComparator,
  },
  // 1ere sous catégorie
];

export const defaultColDef_Ordo_Examen_Comp = {
  suppressMovable: true,
  sortable: true,
  editable: true,
  // cellEditor: 'agLargeTextCellEditor',
  maxLength: 1000,
  flex: 1,
  // filter stuff
  filter: true,
  //   floatingFilter: true,
  // suppressMenu: true,
  // end of filter stuff
  minWidth: 100,
  // resizable: true,
  // tooltipComponent: 'customTooltip',
  filterParams: {
    newRowsAction: "keep",
    // buttons: ['apply', 'clear'],
  },
  resizable: true,
  cellClass: "cell-wrap-text",
  autoHeight: true,
};
